import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BaseUrl from "../../../../constants/BaseUrl";

const AccountWalletTile = ({ propertyId }) => {
  const { loginSuccess } = useSelector((state) => state.auth);
  const [balance, setBalance] = useState(null);
  const [asOn, setAsOn] = useState(null);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!propertyId) return;

    setLoading(true);
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${loginSuccess?.token}`);

    fetch(`${BaseUrl}api/accountMapping/walletBalance/${propertyId}`, {
      method: "GET",
      headers,
      redirect: "follow",
    })
      .then((r) => r.json())
      .then((result) => {
        if (result.status === "success" && result.data?.availableBalance !== undefined) {
          setBalance(result.data.availableBalance);
          setAsOn(result.data.asOn || null);
          setVisible(true);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [propertyId]);

  if (!loading && !visible) return null;

  return (
    <div className="w-full bg-white rounded-lg px-5 py-5">
      <p className="text-darkColor font-popinsSemiBold text-lg mb-4">Account Wallet</p>

      {loading ? (
        <div className="flex items-center gap-3">
          <div className="w-5 h-5 border-4 border-themeColor border-t-transparent rounded-full animate-spin" />
          <span className="text-darkColor/40 font-popinsRegular text-sm">Fetching balance...</span>
        </div>
      ) : (
        <div className="rounded-xl border border-gray-100 overflow-hidden">
          <div className="flex items-center gap-2 px-4 py-2.5 bg-gray-50 border-b border-gray-100">
            <p className="text-themeColor font-popinsSemiBold text-sm">Available Balance</p>
          </div>
          <div className="px-4 py-3 bg-gray-50 flex flex-col items-center">
            <p className="text-darkColor font-popinsSemiBold text-2xl">
              ${parseFloat(balance).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
            <p className="text-darkColor/40 font-popinsRegular text-xs mt-1">
              <span className="font-popinsMedium text-darkColor/60">As Of</span> {asOn || "—"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountWalletTile;
